module.exports = __webpack_public_path__ + "img/mobileiot1.638a062f.png";